export default "__VITE_PUBLIC_ASSET__4ca167fc__"